const de = {
    // 🔹 Chat

    "front.faq.chat.title": "EINE FRAGE STELLEN",
    "front.faq.chat.description": "sofortige Unterstützung für Restaurantgäste",
    "front.faq.chat.welcome": "Hier können Sie direkt eine Frage stellen.",
    "front.faq.chat.placeholder": "Nachricht",
    "front.faq.chat.send": "senden",
    "front.faq.chat.unsupportedLanguage": "Sorry, this chat currently supports only English and German.",
    "front.faq.chat.fallback": "Danke für Ihre Nachricht. Im Moment kann ich nur häufige Fragen beantworten. Bitte kontaktieren Sie uns direkt für weitere Informationen.",
    "front.faq.chat.answer.hours": "Wir sind täglich von 10:00 bis 22:00 Uhr geöffnet.",
    "front.faq.chat.answer.reservation": "Ja, Sie können einen Tisch direkt über unsere Website oder telefonisch reservieren.",
    "front.faq.chat.answer.groupReservation": "Für Gruppenreservierungen kontaktieren Sie uns bitte direkt, damit wir die beste Option für Sie finden können.",
    "front.faq.chat.answer.address": "Unsere Adresse ist: Musterstraße 1, Berlin.",
    "front.faq.chat.answer.parking": "Ja, in der Nähe stehen Parkmöglichkeiten zur Verfügung.",
    "front.faq.chat.answer.phone": "Sie können uns unter +49 000 000000 kontaktieren.",
    "front.faq.chat.answer.payment": "Ja, Sie können bei uns bar oder mit Karte bezahlen.",
    "front.faq.chat.answer.menu": "Unsere aktuelle Speisekarte finden Sie auf der Website. Bei Fragen zu einzelnen Gerichten helfen wir Ihnen gern weiter.",
    "front.faq.chat.answer.vegetarian": "Ja, wir bieten vegetarische Gerichte an.",
    "front.faq.chat.answer.vegan": "Ja, wir haben auch vegane Optionen auf unserer Speisekarte.",
    "front.faq.chat.answer.allergens": "Wenn Sie Allergien oder Unverträglichkeiten haben, sprechen Sie uns bitte an. Wir helfen Ihnen gern mit Informationen zu den Zutaten weiter.",
    "front.faq.chat.answer.takeaway": "Ja, Speisen können auch zum Mitnehmen bestellt werden.",
    "front.faq.chat.answer.delivery": "Im Moment bieten wir nur Reservierungen und Fragen über die Website an.",
    "front.faq.chat.answer.terrace": "Ja, bei gutem Wetter können Sie auch auf unserer Terrasse sitzen.",
    "front.faq.chat.answer.pets": "Bitte kontaktieren Sie uns direkt, wenn Sie mit einem Haustier kommen möchten.",
    "front.faq.chat.answer.children": "Ja, Familien mit Kindern sind bei uns herzlich willkommen.",
    "front.faq.chat.answer.wifi": "Ja, unseren Gästen steht WLAN zur Verfügung.",

    "front.faq.chat.answer.hours": "",
    "front.faq.chat.answer.reservation": "",
    "front.faq.chat.answer.address": "",
    "front.faq.chat.answer.phone": "",
    "front.faq.chat.answer.delivery": "",


    "front.acquaintance.callback.placeholder": "Ihre Telefonnummer",
    "front.acquaintance.callback.send": "Senden",
    "front.acquaintance.callback.sending": "Wird gesendet...",
    "front.acquaintance.callback.invalidPhone": "Bitte geben Sie eine gültige Telefonnummer ein.",
    "front.acquaintance.callback.success": "Anfrage gesendet. Ich werde Sie bald kontaktieren.",
    "front.acquaintance.callback.error": "Fehler beim Senden der Anfrage. Bitte versuchen Sie es erneut.",

    "front.landingSeo.links.digitalMenu": "Digitale Speisekarte für Restaurants",
    "front.landingSeo.links.qrMenu": "QR-Code Speisekarte erstellen",
    "front.landingSeo.links.multilingualMenu": "Mehrsprachige Speisekarte für Restaurants",
    "front.landingSeo.links.reservation": "Online-Tischreservierung für Restaurants",
    "front.landingSeo.links.freeDigitalMenu": "Digitale Speisekarte kostenlos testen",
    "front.landingSeo.links.changeMenuOnline": "Speisekarte online ändern",



    "menu.title": "Menü",
    "menu.promo": "Sonderangebote",
    "menu.empty.categoryTitle": "Kategorienamen ausfüllen",
    "menu.empty.itemTitle": "Produktnamen ausfüllen",
    "menu.empty.itemDescription": "Produktbeschreibung ausfüllen",
    "cart.add": "In den Warenkorb",
    "cart.cancel": "Abbrechen",
    "section.video": "Video-Präsentation",
    "section.tables": "ONLINE TISCHRESERVIRUNG",
    "section.table": "WÄHLEN SIE EINEN TISCH",
    "section.menu": "Restaurantmenü",
    "section.faq": "Fragen & Antworten",
    "section.contact": "Kontakt",
    "promo.buy": "kaufen",

    "front.tenant.resolving": "Restaurant wird anhand der Subdomain erkannt…",
    "front.tenant.notFound": "Kein Kunde für diese Subdomain gefunden",
    "front.tenant.resolveError": "Fehler beim Ermitteln des Kunden",
    "front.menu.loading": "Wird geladen…",
    "front.menu.loadError": "Fehler beim Laden des Menüs",
    "front.menu.addtocart": "Warenkorb",
    "front.menu.cancel": "Cansel",
    "front.Number.servings": "Anzahl der Portionen",

    // 🔹 Orbit labels
    "orbit.menu": "MENÜ",
    "orbit.shef": "RESERVIERUNG",
    "orbit.video": "VIDEO",
    "orbit.faq": "FRAGEN",
    "orbit.interior": "INTERIEUR",
    "orbit.footer": "SOZIALE MEDIEN",

    // 🔹 ShefSection
    "shef.title.line1": "ONLINE",
    "shef.title.line2": "RESERVIERUNG",
    "shef.banner.label": "Wählen",
    "shef.banner.main": "Sie einen Tisch",
    "shef.reserved": "RESERVIERT",

    //----VIDEO-----//
    "video.title": "SO KOCHEN WIR - EHRLICH UND LECKER",
    "video.add": "Video hinzufügen",
    "add.video.but":"Hinzufügen",

    //-----INTERIOR-----//
    "interior.title": "UNSER INTERIEUR",

    //-----FOOTER------//
    "footer.kontact": "KONTAKTE",

    //-----TELEGRAM------//
    "telegram.title": "Um Telegram-Bestellbenachrichtigungen einzurichten, müssen Sie Folgendes tun:",
    "telegram.title.first": "1. BOT_TOKEN abrufen",
    "telegram.text.first": "Um ein BOT_TOKEN zu erhalten, suchen und starten Sie den @BotFather-Bot in Telegram, senden Sie den Befehl /newbot, folgen Sie den Anweisungen, um einen eindeutigen Bot-Namen und Benutzernamen zu erstellen, und kopieren Sie dann das API-Token, das @BotFather als Antwort sendet",
    "telegram.title.two": "2. CHAT-ID abrufen",
    "telegram.text.two": "Um die CHAT_ID zu erhalten, suchen und starten Sie den Bot @UserInfoBot in Telegram, senden Sie den Befehl /start und kopieren Sie dann die ID, die Sie in der Antwortnachricht erhalten",

    // --- CART (Cart.jsx) ---
    "cart.title": "IHR WARENKORB",
    "cart.header.aria": "Ihr Warenkorb",

    "cart.toggle.expand": "Warenkorb erweitern",
    "cart.toggle.collapse": "Warenkorb reduzieren",

    "cart.total.label": "Gesamt",
    "cart.total.products": "Produkte",

    "cart.button.primary": "aufgeben",
    "cart.button.back": "zurück",
    "cart.button.waiter": "WAITER",

    "cart.mode.takeaway": "nimm es mit",
    "cart.mode.tableTime": "Zeit und Tisch",
    "cart.mode.tableTime.disabled": "keine freien Tische",
    "cart.mode.tableTime.tooltip": "Zeit und Tisch",
    "cart.mode.tableTime.tooltipNoFree": "keine freien Tische",
    "cart.mode.inHouse": "in der Einrichtung",

    "cart.bookingFlow.title": "RESERVIERUNG. TISCHNUMMER",

    "cart.deposit.itemTitle": "Tischreservierung (Deposit)",
    "cart.deposit.lineTitle": "Deposit",
    "cart.deposit.badge": "Deposit {amount}€",

    "cart.table.msg.tempChosen": "Tisch {table} vorläufig gewählt ✓",
    "cart.table.msg.noFree": "Leider gibt es keine freien Tische",
    "cart.table.msg.chooseOrDefault": "Bitte wählen Sie einen Tisch oder lassen Sie die Standardauswahl.",

    "cart.table.select.reserved": "RESERVIERT",
    "cart.table.select.pick": "WÄHLEN",
    "cart.table.select.any": "BELIEBIG",

    "cart.inHouse.title": "WÄHLEN SIE IHRE TISCHNUMMER",
    "cart.inHouse.select.placeholder": "Tisch wählen",
    "cart.inHouse.select.option": "Tisch #{n}",

    "cart.checkout.back": "Zurück",

    "cart.payment.preparing": "Vorbereitung der Zahlung…",
    "cart.loading": "Wird geladen…",

    // --- MockCheckoutPanel (de) ---
    "mockCheckout.title.paymentMethod": "ZAHLUNGSART",

    "mockCheckout.method.card": "Bankkarte",
    "mockCheckout.method.paypal": "PayPal",
    "mockCheckout.method.gpay": "Google Pay",

    "mockCheckout.cardForm.title": "GEBEN SIE DIE KARTENDATEN EIN",
    "mockCheckout.cardForm.numberLabel": "KARTENNUMMER",

    "mockCheckout.error.invalidCardNumber": "Ungültige Kartennummer",
    "mockCheckout.error.enter16Digits": "Bitte 16 Ziffern eingeben",
    "mockCheckout.error.expiryFormat": "Format MM/YY",
    "mockCheckout.error.expiryMonthRange": "Monat 01–12",
    "mockCheckout.error.cardExpired": "Karte abgelaufen",
    "mockCheckout.error.cvc3Digits": "3 Ziffern",

    "mockCheckout.error.sendTelegram": "Fehler beim Senden an Telegram",
    "mockCheckout.error.generic": "Es ist ein Fehler aufgetreten",

    "mockCheckout.reserve.clientNotFound": "Kunde nicht gefunden",
    "mockCheckout.reserve.tablesNotFound": "Beim Kunden gibt es keinen Abschnitt „tables“",
    "mockCheckout.reserve.tableNotFound": "Tisch nicht gefunden",
    "mockCheckout.reserve.alreadyReserved": "Dieser Tisch wurde gerade belegt. Bitte wähle einen anderen.",
    "mockCheckout.reserve.noFreeTables": "Zurzeit keine freien Tische",
    "mockCheckout.reserve.tableNotSelected": "Bitte wähle einen Tisch",
    "mockCheckout.reserve.genericError": "Reservierungsfehler",

    "mockCheckout.button.back": "zurück",
    "mockCheckout.button.pay": "ZAHLEN",
    "mockCheckout.button.sending": "…senden",
    "mockCheckout.button.paid": "...",
    "mockCheckout.button.payInvalidTitle": "Bitte prüfen Sie die Kartendaten",


    "admin.booking.lead.title": "MINDESTRESERVIERUNGSZEIT",
    "admin.booking.lead.note": "Dies betrifft nur Gästereservierungen im Modus „Tisch und Zeit“. Das Zeitintervall beträgt 30 Minuten.",

    // DateTimeStep


    "dateTimeStep.select.time": "WÄHLEN SIE IHRE ZEIT",

    // ---------- ADMIN ----------
    "admin.title": "ADMIN SEITE",
    "admin.loading": "Laden…",
    "admin.nav.delete": "Löschen",

    "admin.nav.back": "Zurück",
    "admin.nav.next": "WEITER",
    "admin.nav.confirm": "SPEICHERN",
    "admin.nav.confirm.now": "jetzt sparen ...",
    "admin.booking.settings": "Buchungseinstellungen",
    "admin.booking.deposit": "EINZAHLUNGSBETRAG",
    "admin.booking.deposit.note": "Bei reiner Tischreservierung ist eine Anzahlung erforderlich",

    "admin.hub.editmenu": "BEARBEITUNGSMENÜ",
    "admin.hub.qr": "QR-CODE",
    "admin.hub.prices": "IHR TARIF",
    "admin.hub.settings": "EINSTELLUNGEN",

    "admin.panel.editmenu": "Bearbeitungsmenü",
    "admin.validation.required" : "Pflichtfeld",
    "admin.panel.add": "Position hinzufügen",
    "admin.panel.menu": "Menü bearbeiten",
    "admin.panel.telegram": "Telegram",
    "admin.panel.table": "TISCHVERWALTUNG",
    "admin.set.table": "Hallen / Tische",
    "admin.set.logo": "Logo und Hintergründe",
    "admin.logo.successfully.applied": "Logo erfolgreich angewendet",
    "admin.logo.download.error": "Downloadfehler",
    "admin.settings.number.rooms": "Anzahl der Säle",
    "admin.settings.room": "Saal",

    "admin.qr.title": "QR-Code für Gäste",
    "admin.qr.alt": "QR-Code für Restaurant",
    "admin.qr.copy": "Link kopieren",
    "admin.qr.copied": "✓ kopiert",
    "admin.qr.note": "Gäste können diesen Code scannen, um Ihre Seite sofort zu öffnen.",

    "admin.link.notfound": "Link nicht gefunden",

    "admin.table.info": "Die Tabellenverwaltung ist auf dieser Seite verfügbar. Der Status ändert sich durch den Druck.",

    "admin.prices.temp": "Preise sind vorübergehend nicht verfügbar",

    "admin.forgot.password": "Passwort vergessen?",

    "admin.success.description": "Klicken Sie auf OK und fügen Sie ein weiteres Produkt hinzu",

    "order.success": "Artikel zum Warenkorb hinzugefügt!",
    "order.error": "Der Artikel ist bereits im Warenkorb",

    "popap.product.removal": "Produktentfernung",
    "popap.category.removal": "Eine Kategorie entfernen",
    "popap.want.delete.product": "Sind Sie sicher, dass Sie das Produkt löschen möchten",
    "popap.want.delete.category": "Möchten Sie die Kategorie wirklich löschen?",

    "admin.settings.guestLang": "Hauptsprache für Gäste",
    "admin.settings.adminLang": "Hauptsprache für Admin",
    "admin.settings.noteGuest": "Diese Sprache wird als Standardsprache gesetzt, wenn Gäste die Seite öffnen",
    "admin.settings.noteAdmin": "Diese Sprache wird als Standardsprache im Admin-Bereich gesetzt",
    "admin.language": "Sprache",
    "admin.settings.logo": "Logo der Einrichtung",
    "admin.settings.logo.text": "Laden Sie Ihr Logo hoch (PNG/JPG/WEBP/SVG, bis zu 2 MB). Klicken Sie anschließend auf „Speichern“. Dadurch wird das aktuelle Logo durch das neue ersetzt",
    "admin.settings.backtable": "Hintergrundbild auf dem Bildschirm zur Auswahl von Tabellen",
    "admin.settings.backhome": "Hintergrundbild des Startbildschirms",
    "admin.settings.backtable.text": "Laden Sie ein Hintergrundbild (SVG/PNG/JPG/WEBP) hoch. Klicken Sie anschließend auf „Speichern“. Dadurch wird der aktuelle Hintergrund durch das neue ersetzt",
    "admin.settings.language.visitors": "Hauptsprache für Besucher der Einrichtung",
    "admin.settings.language.visitors.text": "Diese Sprache wird als primäre Sprache festgelegt, wenn Gäste die Seite öffnen",
    "admin.settings.language.admin": "Die Hauptsprache für Ihr Admin-Panel",
    "admin.settings.language.admin.text": "Diese Sprache wird beim Öffnen des Admin-Panels als Standardsprache festgelegt",
    "admin.settings.gallery": "Galerie",
    
    "admin.settings.social": "Soziale Netzwerke",
    "admin.settings.number.tables": "Anzahl der Tische",
    "admin.settings.how.many.tables": "Wie viele Tische gibt es in dem Lokal?",
    "admin.settings.tables.test": "Speichern Sie die Anzahl der Tabellen und kehren Sie zum vorherigen Tab zurück, um die Einstellungen für jede Tabelle einzeln zu konfigurieren.",
    "admin.settings.upload.panoramic": "Laden Sie ein Panoramabild der Halle Ihrer Einrichtung hoch",
    "admin.settings.table": "Tisch",
    "admin.settings.table.not.found": "Tabelle nicht gefunden",
    "admin.settings.contact.details": "Kontaktdaten",
    "admin.contacts.company": "Name der Firma",
    "admin.contacts.address": "Adresse",
    "admin.contacts.phone": "Telefonnummer",
    "admin.socials.title": "Soziale Medien",
    "admin.settings.rooms.hint": "Bitte geben Sie die Anzahl der Zimmer in der Einrichtung an",

    "admin.settable.title": "Schritt 3. Tabellennummerierung",
    "admin.settable.text1": "Jedes Etikett hat eine Nummer; ordnen Sie die Etiketten entsprechend den Tabellennummern an.",
    "admin.settable.text2": "Verwenden Sie den Schalter, um die Beschriftungsgröße zu ändern.",
    "admin.settable.text3": "Speichern Sie die Daten der aktuellen Tabelle und klicken Sie auf das entsprechende Symbol, um zwischen den Tabellen zu wechseln.",
    "admin.setqr.title": "Ihre QR-Codes",
    "admin.setqr.text1": "auf dieser Seite werden Ihre Nachrichten, Menüs und QR-Codes gespeichert",
    "admin.setqr.text2": "beim Kauf eines BASE-Tarifs wird automatisch ein QR-Code und ein Link zu Ihrer Subdomain generiert (z. B. example.best-place.club)",
    "admin.setqr.text3": "sie können dem Link folgen, ihn kopieren und den QR-Code auch als Bild auf Ihrem Gerät speichern",
    "admin.setpanorama.title": "Step 2. Panoramic image",
    "admin.setpanorama.text1": "Add a panoramic image. It is recommended to use lightweight files (e.g. WEBP format)",
    "admin.setpanorama.text2": "If the image has been uploaded successfully, you will see it in the preview below.",
    "admin.setnumber.title": "Step 1. Amount of salts",
    "admin.setnumber.text1": "Wählen Sie die Anzahl der Tische in Ihrem Lokal.",
    "admin.setnumber.text2": "Es wird empfohlen, mit ein oder zwei Tischen zu beginnen und die Anzahl dann zu erhöhen.",

    "admin.current.logo": "Aktuelles Logo",
    "admin.add.photo": "hier können Sie ein Foto hinzufügen",
    "admin.add.file": "Datei-Upload-Formate: .xlsx, .xls, .csv",
    "admin.import.format": "Spaltenformat: Kategorie / Titel / Beschreibung / Preis",
    "admin.import.follow": "halten Sie sich an das vorgegebene Spaltenformat und erstellen Sie eine Datei im entsprechenden Format",
    "admin.import.BeСareful": "Achtung: Beim Import gehen alle bisherigen Daten verloren",
    "admin.add.photo.but": "Hinzufügen",
    "admin.add.photo.set": "Foto hinzufügen",

    "admin.wizard.step1": "Kategorie wählen",
    "admin.wizard.step2": "Name & Preis",
    "admin.wizard.step3": "Beschreibung & Foto",
    "admin.wizard.ready": "Fertig",
    "admin.wizard.defaultTitle": "Produkt hinzufügen",
    "admin.wizard.step1.desc": "Schritt 1. Wählen Sie eine Kategorie aus den bestehenden aus oder erstellen Sie eine neue",
    "admin.wizard.step2.desc": "Schritt 2. Wählen Sie einen Namen für Ihr Produkt in beiden Sprachen und legen Sie einen Preis fest.",
    "admin.wizard.step3.desc": "Schritt 3. Verfassen Sie eine Produktbeschreibung in beiden Sprachen, fügen Sie ein Bild hinzu und klicken Sie auf Speichern.",
    "admin.wizard.step1.desc.short": "Schritt 1. Wählen Sie eine bestehende oder neue Kategorie aus",
    "admin.wizard.step2.desc.short": "Schritt 2. Fügen Sie den Namen und den Preis des Produkts hinzu",
    "admin.wizard.step3.desc.short": "Schritt 3. Beschreiben Sie das Produkt und fügen Sie ein Foto hinzu",
    
    "admin.wizard.tab.existing": "Bestehend",
    "admin.wizard.tab.new": "Neu",

    "admin.wizard.cat.loading": "Laden…",
    "admin.wizard.cat.empty": "Noch keine Kategorien. Wechsle zu „Neu“ und erstelle die erste.",

    "admin.form.categoryKeyDe": "Kategorie (KEY/DE)",
    "admin.form.categoryEn": "Kategorie (EN)",
    "admin.form.titleMain": "Produktname",
    "admin.form.descMain": "Beschreibung des Produkts",
    "admin.validation.req": "Geben Sie den Produktnamen ein",
    "admin.form.titleDe": "Titel (DE)",
    "admin.form.titleEn": "Titel (EN)",
    "admin.form.nameDe": "Name (DE)",
    "admin.form.nameEn": "Name (EN)",
    "admin.form.price": "Preis",
    "admin.form.descDe": "Beschreibung (DE)",
    "admin.form.descEn": "Beschreibung (EN)",

    "admin.toast.productAdded": "Produkt erfolgreich hinzugefügt",
    "admin.tooltip.fixFormErrors": "Bitte behebe die Fehler im Formular",

    "admin.validation.firstCharNotDigit": "Das erste Zeichen darf keine Zahl sein",
    "admin.validation.maxChars": "Produktnamen verkürzen",
    "admin.validation.chooseCategory": "Wähle eine Kategorie",
    "admin.validation.chooseCategoryFromList": "Wähle eine Kategorie aus der Liste",
    "admin.validation.enterCategoryName": "Gib einen Kategorienamen ein",
    "admin.validation.enterProductName": "Gib einen Produktnamen ein.",
    "admin.validation.priceFormat": "Ungültiges Preisformat (z. B. 12.50)",
    "admin.validation.enterDescription": "Gib eine Beschreibung ein.",
    "admin.tarif.apply": "anwenden",
    "admin.menu.creating": "Menü erstellen",
    "admin.choose.template": "Schritt 1: Wählen Sie eine Vorlage aus",
    "admin.choose.template2": "Schritt 2: Überprüfen Sie die Produktlinien",
    "admin.choose.atyle": "Wählen Sie einen Menüstil. Sie können ihn später ändern",


    "admin.error.tenantNotFound": "Kein Kunde für diese Subdomain gefunden",
    "admin.error.resolveClient": "Fehler beim Ermitteln des Kunden",
    "admin.error.menuLoad": "Menü konnte nicht geladen werden",
    "admin.error.saveLang": "Sprache konnte nicht gespeichert werden",
    "admin.error.clientNotFound": "Client auf dem Server nicht gefunden",
    "admin.error.arrNotFound": "Für diesen Client wurde kein Datenarray gefunden",

    "tpl.premium.title": "Premium",
    "tpl.classic.title": "Clasic",
    "tpl.dark.title": "Dunkel",
    "tpl.minimal.title": "Minimal",
    "tpl.premium.desc": "Top-Seller",
    "tpl.classic.desc": "hell",
    "tpl.dark.desc": "dunkel",
    "tpl.minimal.desc": "minimal",

    "tp2.position.total": "Sie haben nun:",
    "tp2.position.punkte": "Menüpunkte",
    "tp2.position.template": "Vorlage",

    "tp3.qr.link": "QR-Code und Menülink",
    "tp3.step3.title": "Schritt 3: Vorschau / Veröffentlichen",
    "admin.tp.publish": "Veröffentlichen",
    "admin.tp.posting": "posten ...",

    "admin.import.from.excel": "Menü aus Excel importieren",

    "tp4.link.copy": "COPIEREN",
    "tp4.link.copy.ok": "✓ COPIERT",


    "popap.successful.payment": "Erfolgreiche Zahlung",
    "admin.tp.progres.publication": "Veröffentlichung",
    "admin.tp.progres.positionen": "Positionen",



    /*--------LANDING-----------*/

    "landing.title": "Digitale Lösungen für Restaurants",
    "landing.title.login": "Einloggen",
    
    "landing.text": "Bringen Sie Ihre Restaurant-Website in wenigen Minuten zum Laufen!",
    "landing.try.now": "Probieren Sie es kostenlos aus",
    "landing.title.to": "Für wen ist unser Service geeignet?",
    "landing.title.answer": "In erster Linie wird es für die Inhaber von Betrieben nützlich sein, deren Aufgabe es ist, neue Kunden zu gewinnen und bestehende Kunden zu halten",
    "landing.content.title.first": "Online-Speisekarte mit QR-Code",
    "landing.content.first": "Ihre Besucher können sich auf eine aktuelle Speisekarte und aktuelle Preise verlassen, indem sie einfach den QR-Code scannen, und Sonderangebote werden die Kundenbindung zu Ihrem Produkt erhöhen",
    "landing.content.title.second": "Online-Tischreservierungen",
    "landing.content.second": "Wir präsentieren Ihrem Berater eine visuelle Online-Tischreservierung mit zusätzlichen Panoramabildern. Bei Bedarf können Sie zwischen benachbarten Einzahlungsbereichen wechseln",
    "landing.content.title.third": "Atmosphärischer Inhalt",
    "landing.content.third": "Ihre potenziellen Besucher haben die Möglichkeit, sich verschiedene Inhalte anzusehen: Fotos vom allgemeinen Interieur, Videos von der Zubereitung erstklassiger Gerichte und einen Panoramablick auf die Besucherhalle",
    "landing.content.title.four": "Steigern Sie Ihren Umsatz",
    "landing.content.four": "Bieten Sie Ihren Gästen Veranstaltungen wie Bankette, Geburtstage oder Sonderangebote für aufwendige oder alltägliche Bestellungen an",
    "landing.request": "Wir werden uns in Kürze bei Ihnen melden.",
    "callback.invalidPhone": "Bitte geben Sie eine gültige Telefonnummer ein",
    "landing.enter.number":"IHRE NUMMER",
    "callback.submitError": "Nummer konnte nicht gesendet werden. Bitte versuchen Sie es erneut",
    "landing.tariff.advance": "Warnung",
    "landing.tariff.advance.desc": "Innerhalb des gewählten Tarifs können Sie Ihre Anwendung kostenlos mit Inhalten füllen",
    "landing.tariff.one-time-not-included": "Individuelle Preisberechnung. In der rechten oberen Ecke des Bildschirms finden Sie einen Kontaktbutton. Hinterlassen Sie Ihre Telefonnummer, wir melden uns bei Ihnen",
    "landing.tariff.one-time-services" : "Einmalige Leistungen",
    "landing.tariff.logo-creation": "Logoerstellung",
    "landing.tariff.selling-images": "Verkauf von Produktbildern",
    "landing.tariff.panorama-creation": "Panoramaerstellung",

    "demo.video.unsupported": "Ihr Browser unterstützt kein Video",
    "demo.title.after": "Überblick über den Service",
    "demo.title.accent": "kurzer",
    "demo.title.before": "Ein",
    "demo.title.total": "über den Service",
    "demo.title": "Video-Überblick",



    /*--------tarif--------*/

    "landing.free.first": "Online-Speisekarte per QR-Code verfügbar, Bearbeitung möglich",
    "landing.free.second": "Die Möglichkeit, das Menü für das aktuelle Datum zu bearbeiten",
    "landing.free.third": "Zugriff auf den Menüdesigner",
    "landing.basic.first": "Eine vollständige URL-Seite mit Menüzugriff per QR-Code",
    "landing.basic.second": "Online-Bestellmöglichkeit für Ihre Besucher",
    "landing.basic.third": "Online-Tischreservierungen, Panoramafotos Ihres Speisesaals, anklickbare Tische und Echtzeitanzeige reservierter und freier Tische",
    "landing.basic.fourth": "Menü mit Übersetzung in jede Sprache",
    "landing.pro.first": "Funktionen, mit denen Sie Preisangebote verwalten, Banner erstellen und Marketingstrategien entwickeln können",
    "landing.pro.second": "Die Fähigkeit, das Gästebindungssystem des Betriebs zu verwalten und das Endergebnis der Bewertungen auf Google zu beeinflussen",
    "landing.pro.third": "",
    "landing.registerTitle": "Registrierung",
    "landing.title.free": "14 Tage kostenlos",
    "landing.tariff.selection": "Tarif wählen",
    "landing.tariff.subdomain": "Subdomain Registrierung",
    "landing.tariff": "/ pro Monat",
    "landing.your.tariff": "Ihr Tarif",
    "landing.your.example": "Beispiel",
    "landing.tariff.free": "FREI",
    "landing.tariff.free-description": "den Service kennenlernen",
    "landing.tariff.basic": "BASIC",
    "landing.tariff.basic-description": "Basisfunktionen für den Start",
    "landing.tariff.pro": "PRO",
    "landing.tariff.pro-description": "Für fortgeschrittene Benutzer",
    "landing.Subdomain.selection": "Subdomain wählen",
    "landing.password": "passwort",
    "landing.tariff.selected": "✓ ausgewählt",
    "landing.legal.text.start": "Ich stimme",
    "footer.legal.terms": "Bedingungen",
    "landing.legal.text.mid": "und",
    "landing.tariff.optional": "Einmalige Leistungen",
    "landing.tariff.one-time-note": "Preise für die Erstellung hochwertiger, verkaufsfähiger Bilder ansehen",
    "landing.tariff.pro-locked-desc": "Dieser Tarif ist noch nicht verfügbar",
    "landing.tariff.in-development": "In der Entwicklung",
    "landing.tariff.free-one-time-desc":"um Ihren Beitrag mit hochwertigen Bildern zu füllen",
    
    /*--------footer--------*/
    
    "footer.legal.privacy": "Datenschutzerklärung",
    "footer.legal.privacy.and": "zu",
    "footer.about": "Plattform für Restaurants: Speisekarte, Tischreservierungen, Bestellungen und Administrationsbereich",


     

    /*--------server--------*/
    "server.common.unknown": "Unbekannter Fehler.",
    "server.common.serverError": "Interner Serverfehler.",
    "server.common.networkError": "Fehler beim Verbinden mit dem Server.",
    "server.common.clientIdMissing": "Fehler: clientId fehlt.",

    "server.login.required": "Email und Passwort sind erforderlich.",
    "server.login.invalidCredentials": "Falsche Email oder Passwort.",
    "server.login.signupIncomplete": "Account ist noch nicht aktiv. Bitte Registrierung завершити.",
    "server.login.success": "Login erfolgreich!",

    "server.register.required": "Email und Passwort sind erforderlich.",
    "server.register.emailExistsActive": "Ein Benutzer mit dieser Email existiert bereits. Bitte Login verwenden.",
    "server.register.resume": "Registrierung wird fortgesetzt.",
    "server.register.success": "Registrierung erfolgreich!",

    "server.signupComplete.success": "Aktivierung erfolgreich!",
    "server.signupComplete.error": "Aktivierung fehlgeschlagen.",

    "server.subdomain.required": "clientId und subdomain sind erforderlich.",
    "server.subdomain.planInvalid": "Ungültiger Tarif. Erlaubt: free | basic | pro.",
    "server.subdomain.invalid": "Ungültige Subdomain (a-z, 0-9, '-', 3–30, без '-' на початку/кінці).",
    "server.subdomain.reserved": "Diese Subdomain ist reserviert.",
    "server.subdomain.taken": "Diese Subdomain ist bereits vergeben.",
    "server.subdomain.userNotFound": "Benutzer nicht gefunden.",
    "server.subdomain.success": "Subdomain registriert. Weiterleitung…",
    "server.subdomain.error": "Fehler bei der Subdomain-Registrierung.",

    "landing.loginTitle": "Login",
    "landing.btn.login": "Login",
    "landing.btn.register": "Registrierung",
    "landing.btn.enter": "Betreten",
    "landing.loggingIn": "Anmelden…",
    "landing.registering": "Registrierung…",
    "landing.activating": "Aktivierung…",
    "landing.subdomain.registering": "Subdomain wird registriert…",
    "landing.redirecting": "Weiterleitung…",
    "landing.legal.required": "Bitte akzeptiere Terms & Privacy.",

    "landing.subdomain.err.empty": "Bitte geben Sie einen Subdomain-Namen ein.",
    "landing.subdomain.err.chars": "Nur Buchstaben, Zahlen und '-', 3–30 Zeichen.",
    "landing.subdomain.err.hyphen": "Subdomain darf nicht mit '-' beginnen oder enden.",
    "landing.subdomain.err.reserved": "Dieser Subdomain-Name ist reserviert.",

    "admin.menuLanguages.default": "Die Sprache, die ein Besucher Ihres Betriebs als erstes sieht (standardmäßig).",
    "admin.menuLanguages.title": "Menüsprachen",
    "admin.menuLanguages.hint": "Wählen Sie die Sprachen aus, die zusätzlich verwendet werden sollen.",
    "common.success": "Erfolgreich",
    "admin.import.activeLangs": "Aktive Menüsprachen",
  "admin.import.sourceLangHint": "Die Excel-Tabelle wird nur in der ausgewählten Sprache angezeigt. Andere aktive Sprachen bleiben leer",
  "admin.import.sourceLang": "Geben Sie die Sprache an, in der die Excel-Datei geschrieben ist",
  "admin.import.mainLang": "die Hauptsache",
  "booking.date.today": "Heute",
  "booking.date.tomorrow": "Morgen",
  "booking.room": "Raum",

  "front.faq.chat.answer.greeting": "Hallo! Ich helfe Ihnen gerne bei Reservierungen, Menü, Adresse, Öffnungszeiten und weiteren Fragen.",
"front.faq.chat.answer.howAreYou": "Danke, mir geht es gut! Wie kann ich Ihnen rund um unser Restaurant helfen?",
"front.faq.chat.answer.thanks": "Gern geschehen! Melden Sie sich gerne, wenn Sie noch weitere Fragen haben.",
"front.faq.chat.answer.goodbye": "Auf Wiedersehen! Wir freuen uns auf Ihren Besuch.",
"front.faq.chat.answer.whoAreYou": "Ich bin der digitale Assistent des Restaurants und helfe Gästen bei häufigen Fragen.",
"front.faq.chat.answer.help": "Ich kann Ihnen bei Reservierungen, Menü, Adresse, Telefonnummer, Zahlung, Allergenen, Lieferung und weiteren Fragen helfen.",
"front.faq.chat.answer.recommendation": "Schauen Sie gerne in unsere Speisekarte — dort finden Sie alle aktuellen Gerichte und können auswählen, was zu Ihnen passt.",
"front.faq.chat.answer.compliment": "Vielen Dank! Das freut uns sehr.",

"checkout.button.send": "SENDEN",
"checkout.button.sending": "Wird gesendet ...",
"checkout.button.sent": "Gesendet",
"checkout.title.order": "BESTELLUNG",
"checkout.phone.title": "Geben Sie Ihre Telefonnummer ein",
"checkout.phone.label": "Telefonnummer",

"footer.workingHours": "Arbeitszeit",

"admin.offline.title": "Keine Internetverbindung",
"admin.offline.text": "Überprüfen Sie Ihre Internetverbindung. Sobald die Verbindung wiederhergestellt ist, können Sie automatisch weiterarbeiten.",
"admin.offline.status": "Warten auf Verbindung…",

};

export default de;